
import Vue from 'vue'
import CustomTextModal from './CustomTextModal.vue'
import { RInput, RButton } from '@/components'

type ModalState = {
  reason: string
  requirementShown: boolean
}

export default Vue.extend({
  name: 'SubscriptionCancelModal',
  components: {
    CustomTextModal,
    RButton,
    RInput,
  },
  props: {
    pending: {
      type: Boolean,
    },
    endDateString: {
      type: String,
    },
  },
  data(): ModalState {
    return {
      reason: '',
      requirementShown: false,
    }
  },
  methods: {
    handleConfirmCancel(): void {
      const { reason } = this
      if (reason.length <= 5) {
        this.requirementShown = true
        this.focusOnReasonsInput()
        return
      }
      this.$emit('confirm', reason)
    },
    focusOnReasonsInput(): void {
      ;(this.$refs.reasonInput as HTMLInputElement).focus()
    },
    resetModalState(): void {
      this.requirementShown = false
      this.reason = ''
    },
  },
})
